function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ColourPickerIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L7.82843 6.41422L9.24264 5L7.12132 2.87868C5.94975 1.70711 4.05026 1.7071 2.87868 2.87868C1.7071 4.05026 1.70711 5.94975 2.87868 7.12132L5 9.24264L6.41422 7.82843L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7175 7.47488L12.4246 6.76777L11.0104 5.35356L5.35356 11.0104L6.76777 12.4246L7.47488 11.7175L13.7202 17.9628C14.1765 18.4191 14.8073 18.6573 15.451 18.6175L18.4315 18.4315L18.6169 15.4515C18.6573 14.8073 18.4191 14.1765 17.9628 13.7202L11.7175 7.47488ZM15.3271 16.6213C15.2549 16.6257 15.1845 16.5987 15.1344 16.5486L8.88909 10.3033L10.3033 8.88909L16.5486 15.1344C16.5986 15.1844 16.6254 15.2544 16.6209 15.3264L16.545 16.5453L15.3271 16.6213Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M20.5 22C21.3284 22 22 21.3284 22 20.5C22 19.6716 21.3284 19 20.5 19C19.6716 19 19 19.6716 19 20.5C19 21.3284 19.6716 22 20.5 22Z",
    fill: "currentColor"
  }));
}
export function ColourPickerIconSmall(props) {
  return ___EmotionJSX(ColourPickerIcon, _extends({
    size: "small"
  }, props));
}